import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import PropTypes from 'prop-types';
import Modal from 'react-modal';
import { connect } from 'react-redux';
import {asyncConnect} from 'redux-connect';
import {isLoaded as isAuthLoaded, load as loadAuth, logout} from '../../redux/modules/auth';
import {push} from 'react-router-redux';
import styles from './Modal.less';
import renderHTML from 'react-render-html';
import * as commonActions from '../../actions/commonActions';
import * as dashboardActions from '../../actions/dashboardActions';
import * as tradepanelActions from '../../actions/tradepanelActions';
import * as instrumentListActions from '../../actions/instrumentListActions';
import * as marginActions from '../../actions/marginActions';
import * as activityActions from '../../actions/activityActions';
import MUIIcon from '../../components/IconMaterialUI/MUIIcon';
let Flag=false;
let messageHead = 'Previous session exists. Click <a href="#" onClick={handleClick}>here</a> to forced login?';
let messageBody = '';
@connect(
  state => ({
    sessionTimeOut: state.dashboardRoot.dashboardReducer.sessionTimeOut,
  }),{
    logout,
    pushState: push,
    ...commonActions,
    ...dashboardActions,
    ...tradepanelActions,
    ...instrumentListActions,
    ...activityActions
  })
export default class ModalComponent extends Component {
  static propTypes = {
    sessionTimeOut: PropTypes.bool,
    resetState: PropTypes.func.isRequired,
    killSessionTrader:PropTypes.func.isRequired,
    sessionReset:PropTypes.func.isRequired,

  }
  constructor() {
    super();
    this.closeOnRefresh = this.closeOnRefresh.bind(this);
    window.onbeforeunload = this.closeOnRefresh.bind(this);
  }
  closeOnRefresh() {
    try{
      messageHead = 'Session expired !';
      messageBody = 'Please login again.!';
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'closeOnRefresh', component:"ModalComponent"});
    }
  }
  handleClick = (e) => {
    try{
      e.preventDefault();
      localStorage.setItem('logoutClose',true);
      localStorage.setItem('userlogin',null);
      // localStorage.setItem('user',null);
      localStorage.setItem('userDetail',null);
      this.props.sessionReset();
      localStorage.setItem('windowForcedLogin','clear');
      window.location.href = "/login"
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'handleClick', component:"ModalComponent"});
    }
 };

  componentWillMount() {
  }
  render() {
    const version = localStorage.getItem('ver');
    return (
      <div>
        <Modal isOpen={true} className={styles.warningModal} id="prevSessExstModal">
          <span><MUIIcon icon={'Warning'} className={`${styles.iconSuccess} md-48`}/></span>
            <p>Previous session exists. Click <a href="#" onClick={this.handleClick}>here</a> to force login.</p>
        </Modal>
      </div>
    );
  }
}
